module.exports = __webpack_public_path__ + "img/quizz-step-6-5.a8166b53.jpg";